import { motion } from "framer-motion";
import { MonitorDown, Lock, RotateCw, ChevronLeft, Minus, Square, X } from "lucide-react";
import { FakePage, Hot, HOST } from "./parts";

const Browser = ({ hot, children }) => (
  <div className="absolute inset-0 flex flex-col">
    <div className="h-5 bg-slate-200 flex items-end gap-1 px-2"><span className="h-4 w-24 rounded-t-md bg-white text-[8px] px-1.5 pt-0.5 truncate">K Gestionale</span></div>
    <div className="h-7 bg-white border-b border-slate-200 flex items-center gap-1.5 px-2">
      <ChevronLeft className="w-3 h-3 text-slate-500" /><RotateCw className="w-3 h-3 text-slate-500" />
      <div className="flex-1 h-5 rounded-full bg-slate-100 flex items-center justify-between px-2 text-[8px] text-slate-600">
        <span className="flex items-center gap-1 min-w-0"><Lock className="w-2.5 h-2.5 shrink-0" /><span className="truncate">{HOST}</span></span>
        {hot ? <Hot className="p-0.5"><MonitorDown className="w-3 h-3 text-slate-700" /></Hot> : <MonitorDown className="w-3 h-3 text-slate-700" />}
      </div>
    </div>
    <div className="relative flex-1 bg-white">{children}</div>
  </div>
);

const MiniPage = ({ dim }) => <div className={`absolute inset-0 scale-[0.9] origin-top-left ${dim ? "opacity-40" : ""}`}><FakePage /></div>;

export const DesktopIcon = () => (<Browser hot><MiniPage /></Browser>);

export const DesktopPopup = () => (
  <Browser>
    <MiniPage dim />
    <motion.div className="absolute right-2 top-1 z-20 w-40 rounded-lg bg-white shadow-2xl border border-slate-200 p-2.5 space-y-2"
      initial={{ y: -6, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.15 }}>
      <div className="text-[9px] font-bold">Installare l'app?</div>
      <div className="flex items-center gap-1.5 text-[8px]"><img src="/icon-192.png" alt="" className="w-5 h-5 rounded" />K Gestionale</div>
      <div className="flex justify-end gap-2 text-[8px] font-semibold">
        <Hot className="px-1.5 py-0.5 bg-sky-600 text-white rounded">Installa</Hot>
        <span className="px-1.5 py-0.5 rounded border border-slate-300">Annulla</span>
      </div>
    </motion.div>
  </Browser>
);

export const DesktopApp = () => (
  <div className="absolute inset-0 bg-gradient-to-br from-sky-600 to-indigo-700 p-3">
    <motion.div className="flex flex-col items-center w-10 gap-0.5" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", delay: 0.2 }}>
      <img src="/icon-192.png" alt="" className="w-7 h-7 rounded-lg ring-1 ring-white" /><span className="text-[6px] text-white font-semibold">K Gestionale</span>
    </motion.div>
    <motion.div className="absolute right-4 top-4 left-16 bottom-3 rounded-md bg-white shadow-2xl overflow-hidden" initial={{ scale: 0.85, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 0.45 }} data-testid="install-guide-desktop-window">
      <div className="h-5 bg-orange-600 text-white flex items-center justify-between px-1.5 text-[8px] font-semibold">
        <span className="flex items-center gap-1"><img src="/icon-192.png" alt="" className="w-3 h-3 rounded-sm" /> K Gestionale</span>
        <span className="flex gap-1.5"><Minus className="w-2.5 h-2.5" /><Square className="w-2.5 h-2.5" /><X className="w-2.5 h-2.5" /></span>
      </div>
      <div className="relative h-full"><MiniPage /></div>
    </motion.div>
  </div>
);
